import React, { useCallback } from 'react';
import withTheme from '@material-ui/core/styles/withTheme';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { Box, DialogContent, IconButton, Typography } from '@material-ui/core';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { TimesIcon } from '../../icons';

// Alias for backward compatibility
const CloseIcon = TimesIcon;

const DragItem = ({ prov, label, handleDeleteItem }) => {
    return (
        <Box
            ref={prov.innerRef}
            {...prov.draggableProps}
            {...prov.dragHandleProps}
            style={{
                margin: 8,
                padding: '4px 8px',
                border: '1px solid #ccc',
                backgroundColor: '#f9f9f9',
                borderRadius: 8,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                ...prov.draggableProps.style
            }}
        >
            <Typography>{label}</Typography>
            <IconButton size="small" onClick={handleDeleteItem}>
                <CloseIcon fontSize="small" />
            </IconButton>
        </Box>
    );
};

const DragDropModal = ({
    title,
    props = {
        droppableId: 'droppable',
        values: [],
        items: [],
        setItems: () => {},
        // eslint-disable-next-line no-unused-vars
        setFieldValue: _newValue => {}
    },
    close = false,
    showModal,
    MODAL_TYPE
}) => {
    const { droppableId, items, values, setItems, setFieldValue } = props;

    // Local state to trigger re-render on item deletion
    const [listItems, setListItems] = React.useState(items);

    // close defaults to just close the modal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const closeAction = useCallback(close || (() => showModal(MODAL_TYPE.NONE)), [close]);

    const handleDeleteItem = index => {
        values.splice(index, 1);

        const newItems = items.filter(i => values.includes(i.id));
        setItems(newItems);
        setListItems(newItems);
        setFieldValue(values);
    };

    const handleOnDragEnd = result => {
        if (!result.destination) {
            return;
        }
        const [reorderedItem] = values.splice(result.source.index, 1);
        values.splice(result.destination.index, 0, reorderedItem);

        const newItems = items.filter(i => values.includes(i.id));
        setItems(newItems);
        setFieldValue(values);
    };

    return (
        <Dialog
            open
            onClose={closeAction}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <Box
                    style={{
                        minWidth: listItems?.length > 0 ? 450 : 200,
                        minHeight: listItems?.length > 0 ? 200 : 100,
                        maxHeight: 400,
                        overflowY: 'auto'
                    }}
                >
                    {values.length !== 0 ? (
                        <DragDropContext onDragEnd={handleOnDragEnd}>
                            <Droppable droppableId={droppableId}>
                                {provided => (
                                    <span {...provided.droppableProps} ref={provided.innerRef}>
                                        {values.map((value, index) => (
                                            <Draggable
                                                key={index}
                                                draggableId={`${index}`}
                                                index={index}
                                            >
                                                {prov => (
                                                    <DragItem
                                                        prov={prov}
                                                        label={`${index + 1}. ${listItems.find(
                                                            a => a.id === value
                                                        )?.name || `#${value}`}`}
                                                        handleDeleteItem={() =>
                                                            handleDeleteItem(index)
                                                        }
                                                    />
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </span>
                                )}
                            </Droppable>
                        </DragDropContext>
                    ) : (
                        <Typography variant="body1" align="center">
                            No sortable items
                        </Typography>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeAction} variant="contained" color="primary" autoFocus>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default withTheme(DragDropModal);
